export default "__VITE_ASSET__D5$YI$Ue__"